import React from 'react';
import { Link } from 'react-router-dom';

import { useInView } from 'react-intersection-observer';
import { motion, useAnimation } from 'framer-motion';

const variants = {
  hidden: {
    opacity: 0,
    scale: 0, // Start scale at 0
  },
  visible: (index) => ({
    opacity: 1,
    scale: 1, // End scale at 1
    rotate: [0, 4, -4, 0], // Rotate between 0 and 2 degrees
    transition: {
      type: 'spring', // Use spring for a bounce effect
      stiffness: 120, // Tightness of the spring
      damping: 10, // Control the spring bounce
      delay: Math.random() * 0.8 + 0.2, // Alternate delay logic
    },
  }),
  hover: {
    scale: 1.05, // End scale at 1
    rotate: [0, 4, -4, 0], // Rotate between 0 and 2 degrees
  },
};

const ContentItemLocationsBlock = ({ item }) => {
  const { name = '', cta_image = '', friendly_url } = item;

  const controls = useAnimation();

  const { ref, inView } = useInView({
    threshold: 0.15,
    triggerOnce: true,
  });

  React.useEffect(() => {
    inView && controls.start('visible');
  }, [inView]);

  React.useEffect(() => {
    controls.start('hidden');
  }, []);

  return (
    <motion.li
      className="content-item__item"
      key={name}
      variants={variants}
      whileHover="hover"
      animate={controls}
      ref={ref}
    >
      <div className="content-item content-item--locations">
        <Link to={`/explore-porthole/${friendly_url}`}>
          <figure>
            <img src={cta_image} alt={name} title={name} />
          </figure>
        </Link>
      </div>
    </motion.li>
  );
};

export default ContentItemLocationsBlock;
